import { render, staticRenderFns } from "./ManualList.vue?vue&type=template&id=5ec76756"
import script from "./ManualList.vue?vue&type=script&lang=js"
export * from "./ManualList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports